import { render, staticRenderFns } from "./FamilyHistoryDetail.vue?vue&type=template&id=56bce191"
import script from "./FamilyHistoryDetail.vue?vue&type=script&lang=js"
export * from "./FamilyHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports